import React from "react";

const ProjectItem = ({ item }) => {
  return (
    <div className="work_card" key={item.id}>
      <img src={item.image} alt="" className="work_img" />
      <h3 className="work_title">{item.title}</h3>
      <a href={item.link} target="_blank" className="work_button">
        Visit <i className="bx bx-right-arrow-alt work_button_icon"></i>
      </a>
    </div>
  );
};

export default ProjectItem;
